<template>
	<div
		ref="banner"
		class="banner"
		:class="{ stickied: stickied }"
		@mouseenter="[(hovered = true), track('Hero Hover')]"
		@mouseleave="hovered = false"
	>
		<Carousel
			v-if="heroBannerList.length > 0"
			:selected-index="selectedIndex"
			:previous-selected-index="previousSelectedIndex"
		></Carousel>
		<BannerNav v-if="heroBannerList.length > 1" :selected-index="selectedIndex" :hovered="hovered" @setIndex="setIndex"></BannerNav>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import BannerNav from './banner-nav';
import Carousel from './carousel';

export default {
	name: 'HeroBanner',
	components: {
		BannerNav,
		Carousel,
	},
	props: {
		stickied: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			selectedIndex: 0,
			previousSelectedIndex: 0,
			hovered: false,
			xDown: null,
			yDown: null,
		};
	},
	computed: {
		...mapState(['heroBannerList']),
		banner() {
			return this.heroBannerList[this.selectedIndex];
		},
	},
	watch: {
		heroBannerList(val) {
			if (val.length > 0) {
				this.track('Hero View');
			}
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.$refs.banner.addEventListener('touchstart', this.handleTouchStart, false);
			this.$refs.banner.addEventListener('touchmove', this.handleTouchMove, false);
		});
	},
	methods: {
		setIndex(index) {
			this.previousSelectedIndex = this.selectedIndex;
			this.selectedIndex = index;
			this.track('Hero View');
		},
		handleTouchStart(e) {
			const { clientX, clientY } = e.touches[0];
			this.xDown = clientX;
			this.yDown = clientY;
		},
		handleTouchMove(e) {
			if (!this.xDown || !this.yDown || this.heroBannerList.length <= 1) return;

			let xUp = e.touches[0].clientX;
			let yUp = e.touches[0].clientY;

			let xDiff = this.xDown - xUp;
			let yDiff = this.yDown - yUp;

			if (Math.abs(xDiff) > Math.abs(yDiff)) {
				if (xDiff > 0) {
					this.$root.$emit('swipeLeft');
				} else {
					this.$root.$emit('swipeRight');
				}
			}

			this.xDown = null;
			this.yDown = null;
		},
		track(event) {
			if (!this.banner) return;
			dataLayer.push({
				event,
				heroGameName: this.banner.productName,
				heroGameID: this.banner.productId,
			});
		},
	},
};
</script>

<style lang="less" scoped>
.banner {
	height: 471px;
	position: relative;
	width: 100%;
	&.stickied {
		margin-bottom: 100px;
	}
}

@media (min-width: 768px) {
	.banner {
		height: 600px;
	}
}

@media (min-width: 1024px) {
	.banner {
		height: 353px;
	}
}

@media (min-width: 1280px) {
	.banner {
		height: 441px;
	}
}

@media (min-width: 1440px) {
	.banner {
		height: 495px;
	}
}

@media (min-width: 1600px) {
	.banner {
		height: 559px;
	}
}

@media (min-width: 1920px) {
	.banner {
		height: 660px;
	}
}
</style>
